export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.ed3e1a0f.ttf";